<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">积分商城>积分设置</div>
		<div class="newADcontent">
			<div class="adContent">
				<p style="font-size: 20px;margin-top: 10px;"><span style="color: red;">*</span>注意：奖励积分数必须为整数</p>
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">积分设置</div>
				</div>
				<el-form ref="form" label-width="150px" label-position="left">
					<el-form-item label="用户消费行为">
						<!-- <div>
							<p>1、购买权益<span style="color:#bbb">用户完成支付（奖励积分/支付价格）</span></p>
							<el-input type="number" id="1" v-model="setDataList[0].value" placeholder="百分比" style="width: 150px;" size="small"></el-input>%
						</div>
						<div>
							<p>2、剪发<span style="color:#bbb">用户完成支付（奖励积分/支付价格）</span></p>
							<el-input type="number" id="0" v-model="setDataList[1].value" placeholder="百分比"  style="width: 150px;" size="small"></el-input>%
						</div> -->
						<div>
							<p>1、购买权益<span style="color:#bbb">用户完成支付，奖励固定积分数</span></p>
							<el-input type="number" id="1" v-model="setDataList[0].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
						<div>
							<p>2、剪发<span style="color:#bbb">用户完成支付，奖励固定积分数</span></p>
							<el-input type="number" id="0" v-model="setDataList[1].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
						<div>
							<p>3、分销<span style="color:#bbb">被邀请人消费并成功支付，奖励固定积分数</span></p>
							<el-input type="number" id="2" v-model="setDataList[2].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
						<div>
							<p>4、分享有礼<span style="color:#bbb">每位被分享人成功打开链接，奖励固定积分数</span></p>
							<el-input type="number" id="3" v-model="setDataList[3].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
					</el-form-item>

					<el-form-item label="用户属性">
						<p style="color: #bbb;"><span style="color: red;">*</span>用户属性奖励仅适用于剪发订单，每种属性分别奖励固定积分</p>
						<div>
							<span style="width: 150px;">1、首次消费用户</span>
							<el-input type="number" id="11" v-model="setDataList[4].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
						<div>
							<span style="width: 150px;">2、生客</span>
							<el-input type="number" id="12" v-model="setDataList[5].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
						<div>
							<span style="width: 150px;">3、熟客</span>
							<el-input type="number" id="13" v-model="setDataList[6].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
						<div>
							<span style="width: 150px;">4、深度熟客</span>
							<el-input type="number" id="14" v-model="setDataList[7].value" style="width: 150px;"
								size="small"></el-input>积分
						</div>
					</el-form-item>
					<el-form-item label="积分有效期" v-model="setDataList.ruleTypeRemark">
						<p>
							<el-radio label="0">不设期限</el-radio>
						</p>
						<p>
							<el-radio label="1">积分自领取之日起，一年后自动过期</el-radio>
						</p>
						<p style="margin-top: 20px;">
							<el-radio label="2">
								每年
								<el-date-picker size="small" style="width:300px;margin:0 20px;" type="date"
									value-format="yyyy-MM-dd HH:mm" placeholder="清空日期">
								</el-date-picker>
								日自动清空用户积分
							</el-radio>
						</p>
					</el-form-item>
					<el-form-item>
						<el-button @click="$router.push('/integralset')">取消</el-button>
						<el-button type="primary" style="margin-left: 20px;" @click="save()">保存修改</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				setDataList: [{
					//权益订单
					id: 1,
					ruleType: 1,
					type: 1,
					value: 0,
				}, {
					//剪发
					id: 0,
					ruleType: 0,
					type: 1,
					value: 0,
				}, {
					//分销
					id: 2,
					ruleType: 2,
					type: 0,
					value: 0,
				}, {
					//分享有礼
					id: 3,
					ruleType: 3,
					type: 0,
					value: 0,
				}, {
					//首次消费用户
					id: 11,
					ruleType: 11,
					type: 0,
					value: 0,
				}, {
					//生客
					id: 12,
					ruleType: 12,
					type: 0,
					value: 0,
				}, {
					//熟客
					id: 13,
					ruleType: 13,
					type: 0,
					value: 0,
				}, {
					//深度熟客
					id: 14,
					ruleType: 14,
					type: 0,
					value: 0,
				}, ],
				ruleTypeRemark: '', //积分有效期
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			// 获取原积分设置
			getList() {
				this.$http.get("integralRule/list").then(function(res) {
					var a = res.body.data
					this.setDataList = a
					// this.setDataList = {
					// 	appletFenzi = a.appletFenzi;
					// 	appletFenmu = a.appletFenmu;
					// 	cutFenzi = a.cutFenzi;
					// 	cutFenmu = a.cutFenmu;
					// 	retail = a.retail;
					// 	share = a.share;
					// 	newUser = a.newUser;
					// 	strangeUser = a.strangeUser;
					// 	familiarUser = a.familiarUser;
					// 	deepFamiliarUser = a.deepFamiliarUser;
					// 	time = a.time;
					// 	endDate = a.endDate;
					// }
				})
			},
			save() {
				var arr = {};
				// arr.appletFenzi = this.changeIntegral.appletFenzi;
				// arr.appletFenmu = this.changeIntegral.appletFenmu;
				// arr.cutFenzi = this.changeIntegral.cutFenzi;
				// arr.cutFenmu = this.changeIntegral.cutFenmu;
				// arr.retail = this.changeIntegral.retail;
				// arr.share = this.changeIntegral.share;
				// arr.newUser = this.changeIntegral.newUser;
				// arr.strangeUser = this.changeIntegral.strangeUser;
				// arr.familiarUser = this.changeIntegral.familiarUser;
				// arr.deepFamiliarUser = this.changeIntegral.deepFamiliarUser;
				// arr.time = this.changeIntegral.time;
				// arr.endDate = this.changeIntegral.endDate;
				this.$http.post("integralRule/save", JSON.stringify(this.setDataList)).then(function(res) {
					if (res.body.code == "200") {
						if (this.$route.query.id) {
							this.$message.success("修改成功")
						} else {
							this.$message.success("添加成功")
						}
						this.getList()
					} else {
						this.adding = false;
						this.$message.error(res.body.msg)
					}
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			.img {
				width: 300px;
				height: auto;
			}
		}
	}
</style>